import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {withRouter} from '../../helpers/routerCompat';

import LoginLink from './LoginLink';
import utilities from '../../utilities/utilities';
import renderPopup from '../../helpers/renderPopup';
import {openOlarkChat} from '../../helpers/olarkLoader';
import SubscriptionsComponent from './SubscriptionsComponent';
import CTALink from './CTALink';
import {GRIDICS_SITE_LINKS, GTM_CTA_CONTENT} from '../../constants/gtmConstants';

const accountUrl = process.env.REACT_APP_ACCOUNTS_SITE;

const propTypes = {
  isHomePage: PropTypes.bool,
};

function UserBlock({isHomePage = false}) {
  // Get redux states.
  const isMobile = useSelector(state => state.ui.isMobile);
  const mapData = useSelector(state => state.map.mapData);
  const userData = useSelector(state => state.user.userData);

  let blockContent = '';
  const showSubscriptions = (e) => {
    e.preventDefault();
    renderPopup(<SubscriptionsComponent />);
  };

  const switchOlark = (e) => {
    openOlarkChat(e);
  };

  if (utilities.isLoggedIn(userData)) {
    const userName = `${userData.field_user_first_name} ${userData.field_user_last_name}`;
    // Recreate structure of banner gtm data since it differs from other sections.
    const bannerGTMData = {
      EVENT: GTM_CTA_CONTENT.FEASIBILITY_REPORTS.EVENT,
      BANNER_GTM_DATA: {
        category: GTM_CTA_CONTENT.FEASIBILITY_REPORTS.BANNER_GTM_DATA.category,
        action: GTM_CTA_CONTENT.FEASIBILITY_REPORTS.SECTIONS['user-menu'].ACTION,
      },
      SECTIONS: {
        'user-menu': {
          LEARN_MORE: GTM_CTA_CONTENT.FEASIBILITY_REPORTS.SECTIONS['user-menu'].LEARN_MORE,
        },
      },
    };
    blockContent = (
      <React.Fragment>
        <a href={`${accountUrl}/user`} className="user">
          <span className="image avatar">
            <img alt="Avatar" src={userData.picture} title={userName} width="40" height="40" />
          </span>
        </a>
        <div className={`name${!isMobile ? ' hide' : ''}`}>{userName}</div>
        <div className="submenu">
          <ul>
            <li>
              <a href={`${accountUrl}/user/edit?destination-url=${window.location}`}>
                Account Settings
              </a>
            </li>
            {!_.isEmpty(mapData) && (
              <li>
                <a href="#subscriptions" onClick={showSubscriptions}>
                  Subscriptions
                </a>
              </li>
            )}
            <li>
              <CTALink
                url={GRIDICS_SITE_LINKS.REPORTS_LINK}
                displayContent="Download Reports"
                gtmData={bannerGTMData}
                activeSection="user-menu"
                newTab
              />
            </li>
            {/* Contact Us and Signout should always be the last two items in the list */}
            {!isMobile && (
              <>
                <li>
                  <a onClick={e => switchOlark(e)} href="#contact-us">
                    <span className="title">Contact Us</span>
                  </a>
                </li>
                <li>
                  <a href={utilities.getDestinationUrl('logout')}>Sign Out</a>
                </li>
              </>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
  else {
    blockContent = isHomePage ? (
      <div className="homepage-login">
        <LoginLink className="login-link login" urlType="login" text="Login" />
        <LoginLink className="login-link register" urlType="register" text="Create account" />
      </div>
    ) : (
      <ul className="login">
        <li>
          <LoginLink className="login-link" text="Login / Create account" />
        </li>
      </ul>
    );
  }
  return <div className="user-block">{blockContent}</div>;
}

UserBlock.propTypes = propTypes;

export default withRouter(UserBlock);
